var EnvironmentService = /** @class */ (function () {
    function EnvironmentService(api) {
        var _this = this;
        this.fetchEnv = function (app) { return _this.API.get("/environment/", { appId: app }); };
        this.createEnv = function (environment) {
            return _this.API.post('/environment', environment, { appId: environment.app });
        };
        this.updateEnv = function (environment) {
            return _this.API.patch("/environment/".concat(environment === null || environment === void 0 ? void 0 : environment.id), environment, false, {
                appId: environment.app,
            });
        };
        this.updateEnvInApp = function (templateId, appId, envData) {
            return _this.API.patch("/templates/".concat(templateId, "/environments?app=").concat(appId), envData);
        };
        this.deleteEnv = function (app, environment) {
            return _this.API.delete("/environment/".concat(environment), environment, { appId: app });
        };
        this.API = api;
    }
    return EnvironmentService;
}());
export { EnvironmentService };
